import { BottomShadow, MainContainer, PageContent, PageTitle } from '../style';
import { SideBarBack } from '../../../features/side-menu/ui/style';
import React from 'react';
import { LinkExt } from '../../../shared/style/style';

export const Page = () => {
  return (
    <MainContainer>
      <SideBarBack>
        <LinkExt to={'/hot'}>
          <svg width="24" height="18" viewBox="0 0 24 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              fill="white"
              d="M0.84804 8.05701C0.327346 8.57767 0.327346 9.42194 0.84804 9.94261L8.39052 17.4851C8.91121 18.0058
                9.75547 18.0058 10.2761 17.4851C10.7968 16.9645 10.7968 16.1202 10.2761 15.5995L5.0098
                10.3331H22.6667C23.4031 10.3331 24 9.73621 24 8.99981C24 8.26341 23.4031 7.66647 22.6667
                7.66647H5.0098L10.2761 2.40017C10.7968 1.87946 10.7968 1.03525 10.2761 0.514553C9.75547 -0.00615321
                8.91121 -0.00615321 8.39052 0.514553L0.84804 8.05701Z"
            />
          </svg>
        </LinkExt>
      </SideBarBack>
      <PageTitle> 18 U.S.C. 2257 </PageTitle>
      <PageContent>
        <div>
          <p>Last updated May 03, 2023</p>
          <p>Fupp.app is not a producer (primary or secondary) of any and all of the content found on the website (fupp.app). With respect to the records as per 18 USC 2257 for any and all content found on this site, please kindly direct your request to the site for which the content was produced.</p>
          <p>Fupp.app is a photo/video sharing site in which allows for the uploading, sharing and general viewing of various types of adult and non-adult content and while fupp.app does the best it can with verifying compliance, it may not be 100% accurate.</p>
          <p>Fupp.app abides by the following procedures to ensure compliance:</p>
          <p>Requiring all users to be 18 years of age to upload or submit videos. When uploading or submitting, the user must verify the content; assure he/she is 18 years of age; certify that he/she keeps records of the models in the content and that they are over 18 years of age. Fupp.app allows content to be flagged as inappropriate. Should any content be flagged as illegal, unlawful, harassing, harmful, offensive or various other reasons, fupp.app shall remove it from the site without delay.</p>
          <p>Users of fupp.app who come across such content are urged to report the content by sending us an email to reports@fupp.app</p>
        </div>
      </PageContent>
      <BottomShadow />
    </MainContainer>
  );
};
